import { provideDiTokenValue } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { LITSW_REGISTRATION_CONFIG } from '@bcf2-v1-configurators-tokens/litsw-registration/token';
import { registerLitswWorker } from './litsw-registration-core';
import type { LitswRegistrationConfig } from './litsw-registration.types';

export class LitswRegistrationService {
  public register(lang: string): void {
    const config: LitswRegistrationConfig | undefined = provideDiTokenValue(LITSW_REGISTRATION_CONFIG);
    if (!config) {
      return;
    }

    registerLitswWorker(config, lang);
  }
}

export function provideLitswRegistrationService(): LitswRegistrationService {
  return provideSingleton(LitswRegistrationService, () => new LitswRegistrationService());
}
